import React from 'react';
import { useToolbarCollectionContext } from '../ToolbarCollectionContext';
import { MultiLevelSortingCTAButton } from './MultiLevelSortingCTAButton';

export const MultiLevelSorting = () => {
  const state = useToolbarCollectionContext();

  return <MultiLevelSortingCTAButton state={state} />;
};

MultiLevelSorting.displayName = 'MultiLevelSorting';
